import { memoize } from "@/utils/common.utils";

const uiSearchUtils = {
	isMatchAny, // f(keyword, text) => boolean
	// isMatchAll, // f(keyword, text) => boolean
};

export default uiSearchUtils;

/** helpers */
// Split the keyword by space but keep the parts with quotes (example keyword: 'the brown "fox jumps" over')
const splitKeyword = memoize<string[]>((keyword: string): string[] => {
	const keywordParts =
		keyword.toLowerCase().match(/(?:[^\s"]+|"[^"]*")+/gi) ?? [];

	// Remove quotes and white spaces around the words
	return keywordParts.map((part) =>
		escapeRegExp(part.replace(/"/g, "").trim())
	);
});

// Escape any special regex characters
const escapeRegExp = (string: string): string => {
	return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};
/** */

// Returns true if the text contains at least one word of the keyword
function isMatchAny(
	keyword: string | undefined,
	text: string | null | undefined
): boolean {
	if (!text) return false;
	if (!keyword) return true;

	const regex = new RegExp(splitKeyword(keyword).join("|"), "igm");

	return regex.test(text);
}

// Returns true if the text contains all words of the keyword
/*
function isMatchAll(
	keyword: string | undefined,
	text: string | null | undefined
): boolean {
	if (!text) return false;
	if (!keyword) return true;

	const regex = new RegExp(
		"(?=.*" + splitKeyword(keyword).join(")(?=.*") + ")",
		"igm"
	);

	return regex.test(text);
}
*/
